import { Global, css } from "@emotion/react"
import { AppProvider } from "./providers/app"
import { AppRoutes } from "./routes"
import { theme } from "./theme"

export const App = () => {
    return (
        <AppProvider>
            <Global
                styles={css`
                    body {
                        /* スマホで見ることしか想定していないため、横幅を適当に制限する */
                        max-width: ${theme.device.maxWidth}px;
                        margin: 0 auto;
                    }
                `}
            />
            <AppRoutes />
        </AppProvider>
    )
}
